declare global {
  interface Window {
    SkTelemetry?: {
      track: (event: string, payload?: Record<string, unknown>) => void;
      sessionId?: () => string;
      visitorId?: () => string;
    };
  }
}

import { getAbVariant } from "./metrika";

/**
 * Собственная телеметрия воронки продаж (модуль sk_analytics).
 * Контракт событий: Sk\Analytics\Service\TelemetryService (белый список,
 * вход по маяку sk_analytics:Beacon.beacon).
 *
 * Воронка авторизации:
 *  - auth_start            — открыта форма входа/регистрации
 *  - auth_success          — успешная авторизация (любой способ)
 *  - register_success      — завершена регистрация (новый пользователь)
 *  - registration_method   — способ регистрации (A/B-вариант в payload)
 *
 * Никогда не бросает: маяка может не быть на странице.
 */
export const trackTelemetry = (
  event: string,
  payload?: Record<string, unknown>,
): void => {
  try {
    window.SkTelemetry?.track(event, payload);
  } catch {
    // телеметрия не влияет на авторизацию
  }
};

/**
 * Успешная авторизация/регистрация. Для новых пользователей дополнительно
 * фиксирует register_success и registration_method (A/B-контракт).
 */
export const trackAuthSuccess = (params: {
  method: string;
  flow: string;
  is_new_user: boolean;
}): void => {
  trackTelemetry("auth_success", params);

  if (params.is_new_user) {
    trackTelemetry("register_success", params);
    trackTelemetry("registration_method", {
      method: params.method,
      flow: params.flow,
      ab_variant: getAbVariant(),
    });
  }
};
